import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {omit, throwIfUndefined} from '@coolcolduk/util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore/mapFirestoreDocWithTimestamp';
import {mapContentToStudyContent} from './mapContentToStudyContent';
import {StudyDb} from './studyDbSchema';
import {Study, studySchema} from './studySchema';

export function mapStudyDbToType(snapshot: FirestoreDocSnapshotWithIdAndData<StudyDb>): Study {
  const parsed = mapFirestoreDocWithTimestamp(snapshot);
  const data = throwIfUndefined(parsed, 'Study data not found');
  const newData = {
    ...omit(data, 'content'),
    ...(data.content && !data.studyContent ? {studyContent: mapContentToStudyContent(data.content)} : {}),
  };
  return studySchema.parse(newData);
}
